<ng-container [formGroup]="form">
  <section class="ac-info" *ngIf="showInfo && participant" aria-labelledby="ac-info-title">
    <h3 id="ac-info-title">{{ "acceptPage.infoTitle" | translate }}</h3>
    <ul>
      <li *ngFor="let item of info"><strong>{{ item.label }}:</strong> {{ item.text }}</li>
    </ul>
  </section>

  <div class="ac-field" *ngIf="showTerms">
    <label class="ac-check" for="ac-terms">
      <input id="ac-terms" type="checkbox" formControlName="terms"
        [attr.disabled]="termsViewed ? null : ''" aria-describedby="ac-terms-hint" />
      <span>
        {{ "acceptPage.termsBefore" | translate }}
        <a *ngIf="termsUrl" [href]="termsUrl" target="_blank" rel="noopener" (click)="termsViewed = true">{{ "acceptPage.termsLink" | translate }}</a>
        <ng-container *ngIf="!termsUrl">{{ "acceptPage.termsLink" | translate }}</ng-container>{{ "acceptPage.termsAfter" | translate }}
      </span>
    </label>
    <span id="ac-terms-hint" class="ac-help" *ngIf="!termsViewed">{{ "acceptPage.termsHint" | translate }}</span>
    <span class="ac-error" *ngIf="submitted && f['terms'].invalid" aria-live="polite">{{ "acceptPage.errorTerms" | translate }}</span>
  </div>

  <div class="ac-field" *ngIf="participant">
    <label class="ac-check" for="ac-consent">
      <input id="ac-consent" type="checkbox" formControlName="consent"
        [attr.disabled]="consentViewed ? null : ''" aria-describedby="ac-consent-hint" />
      <span>
        {{ "acceptPage.consentBefore" | translate }}
        <a *ngIf="privacyUrl" [href]="privacyUrl" target="_blank" rel="noopener" (click)="consentViewed = true">{{ "acceptPage.consentLink" | translate }}</a>
        <ng-container *ngIf="!privacyUrl">{{ "acceptPage.consentLink" | translate }}</ng-container>
        {{ "acceptPage.consentAfter" | translate }}
      </span>
    </label>
    <span id="ac-consent-hint" class="ac-help" *ngIf="!consentViewed">{{ "acceptPage.consentHint" | translate }}</span>
    <span class="ac-error" *ngIf="submitted && f['consent'].invalid" aria-live="polite">{{ "acceptPage.errorConsent" | translate }}</span>
  </div>
</ng-container>
